import { trackDecoratorWithExtendedLabel } from './mainTrackers';

export const sendAnalyticPrintableWorkoutDownload = () => {
    trackDecoratorWithExtendedLabel('printable_pdf__download__click', undefined, undefined, {
        event_schema_key: 'iglu:com.welltech.walk_fit.web/printable_pdf__download__click/jsonschema/1-0-0',
    });
};
